/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Webplatform-ts V3 API
 * OpenAPI spec version: 3.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PatchV3CustomerAddressByIdBody,
  PostV3CustomerAddressEntitlementsBody,
  PostV3CustomerAddressesBody,
  V3CustomerAddressEntitlement,
  V3CustomerAddressWithEntitlements
} from '../../model';

import { webplatformProxyInstance } from '../../../../../lib/integrations/axios.ts';
import type { ErrorType } from '../../../../../lib/integrations/axios.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns all customer addresses belonging to the authenticated organization with their entitlements
 * @summary List all customer addresses for the organization
 */
export const getV3CustomerAddresses = (

 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<V3CustomerAddressWithEntitlements[]>(
      {url: `/v3/customer-addresses`, method: 'GET', signal
    },
      options);
    }




export const getGetV3CustomerAddressesQueryKey = () => {
    return [
    `/v3/customer-addresses`
    ] as const;
    }


export const getGetV3CustomerAddressesQueryOptions = <TData = Awaited<ReturnType<typeof getV3CustomerAddresses>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3CustomerAddresses>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV3CustomerAddressesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV3CustomerAddresses>>> = ({ signal }) => getV3CustomerAddresses(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV3CustomerAddresses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV3CustomerAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof getV3CustomerAddresses>>>
export type GetV3CustomerAddressesQueryError = ErrorType<unknown>


export function useGetV3CustomerAddresses<TData = Awaited<ReturnType<typeof getV3CustomerAddresses>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3CustomerAddresses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3CustomerAddresses>>,
          TError,
          Awaited<ReturnType<typeof getV3CustomerAddresses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3CustomerAddresses<TData = Awaited<ReturnType<typeof getV3CustomerAddresses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3CustomerAddresses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3CustomerAddresses>>,
          TError,
          Awaited<ReturnType<typeof getV3CustomerAddresses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3CustomerAddresses<TData = Awaited<ReturnType<typeof getV3CustomerAddresses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3CustomerAddresses>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all customer addresses for the organization
 */

export function useGetV3CustomerAddresses<TData = Awaited<ReturnType<typeof getV3CustomerAddresses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3CustomerAddresses>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV3CustomerAddressesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Creates a new customer address with at least one entitlement. The address format is inferred from the address string.
 * @summary Create a new customer address
 */
export const postV3CustomerAddresses = (
    postV3CustomerAddressesBody: PostV3CustomerAddressesBody,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<V3CustomerAddressWithEntitlements>(
      {url: `/v3/customer-addresses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postV3CustomerAddressesBody, signal
    },
      options);
    }




export const getPostV3CustomerAddressesMutationKey = () => ['postV3CustomerAddresses'] as const;

export const getPostV3CustomerAddressesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV3CustomerAddresses>>, TError,PostV3CustomerAddressesMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postV3CustomerAddresses>>, TError,PostV3CustomerAddressesMutationVariables, TContext> => {

const mutationKey = getPostV3CustomerAddressesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postV3CustomerAddresses>>, PostV3CustomerAddressesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postV3CustomerAddresses(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostV3CustomerAddressesMutationResult = NonNullable<Awaited<ReturnType<typeof postV3CustomerAddresses>>>
    export type PostV3CustomerAddressesMutationBody = PostV3CustomerAddressesBody
    export type PostV3CustomerAddressesMutationError = ErrorType<unknown>
    export type PostV3CustomerAddressesMutationVariables = {data: PostV3CustomerAddressesBody}

    /**
 * @summary Create a new customer address
 */
export const usePostV3CustomerAddresses = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV3CustomerAddresses>>, TError,PostV3CustomerAddressesMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postV3CustomerAddresses>>,
        TError,
        PostV3CustomerAddressesMutationVariables,
        TContext
      > => {
      return useMutation(getPostV3CustomerAddressesMutationOptions(options), queryClient);
    }
    /**
 * Returns a customer address with all its entitlements
 * @summary Get a single customer address
 */
export const getV3CustomerAddressById = (
    id: string,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<V3CustomerAddressWithEntitlements>(
      {url: `/v3/customer-addresses/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetV3CustomerAddressByIdQueryKey = (id: string,) => {
    return [
    `/v3/customer-addresses/${id}`
    ] as const;
    }


export const getGetV3CustomerAddressByIdQueryOptions = <TData = Awaited<ReturnType<typeof getV3CustomerAddressById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3CustomerAddressById>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV3CustomerAddressByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV3CustomerAddressById>>> = ({ signal }) => getV3CustomerAddressById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV3CustomerAddressById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV3CustomerAddressByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getV3CustomerAddressById>>>
export type GetV3CustomerAddressByIdQueryError = ErrorType<unknown>


export function useGetV3CustomerAddressById<TData = Awaited<ReturnType<typeof getV3CustomerAddressById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3CustomerAddressById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3CustomerAddressById>>,
          TError,
          Awaited<ReturnType<typeof getV3CustomerAddressById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3CustomerAddressById<TData = Awaited<ReturnType<typeof getV3CustomerAddressById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3CustomerAddressById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3CustomerAddressById>>,
          TError,
          Awaited<ReturnType<typeof getV3CustomerAddressById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3CustomerAddressById<TData = Awaited<ReturnType<typeof getV3CustomerAddressById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3CustomerAddressById>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single customer address
 */

export function useGetV3CustomerAddressById<TData = Awaited<ReturnType<typeof getV3CustomerAddressById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3CustomerAddressById>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV3CustomerAddressByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Updates the nickname of an existing customer address
 * @summary Update a customer address
 */
export const patchV3CustomerAddressById = (
    id: string,
    patchV3CustomerAddressByIdBody: PatchV3CustomerAddressByIdBody,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<V3CustomerAddressWithEntitlements>(
      {url: `/v3/customer-addresses/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchV3CustomerAddressByIdBody, signal
    },
      options);
    }




export const getPatchV3CustomerAddressByIdMutationKey = () => ['patchV3CustomerAddressById'] as const;

export const getPatchV3CustomerAddressByIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchV3CustomerAddressById>>, TError,PatchV3CustomerAddressByIdMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchV3CustomerAddressById>>, TError,PatchV3CustomerAddressByIdMutationVariables, TContext> => {

const mutationKey = getPatchV3CustomerAddressByIdMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchV3CustomerAddressById>>, PatchV3CustomerAddressByIdMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  patchV3CustomerAddressById(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchV3CustomerAddressByIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchV3CustomerAddressById>>>
    export type PatchV3CustomerAddressByIdMutationBody = PatchV3CustomerAddressByIdBody
    export type PatchV3CustomerAddressByIdMutationError = ErrorType<unknown>
    export type PatchV3CustomerAddressByIdMutationVariables = {id: string;data: PatchV3CustomerAddressByIdBody}

    /**
 * @summary Update a customer address
 */
export const usePatchV3CustomerAddressById = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchV3CustomerAddressById>>, TError,PatchV3CustomerAddressByIdMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchV3CustomerAddressById>>,
        TError,
        PatchV3CustomerAddressByIdMutationVariables,
        TContext
      > => {
      return useMutation(getPatchV3CustomerAddressByIdMutationOptions(options), queryClient);
    }
    /**
 * Soft deletes a customer address and all its entitlements
 * @summary Delete a customer address
 */
export const deleteV3CustomerAddressById = (
    id: string,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<boolean>(
      {url: `/v3/customer-addresses/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteV3CustomerAddressByIdMutationKey = () => ['deleteV3CustomerAddressById'] as const;

export const getDeleteV3CustomerAddressByIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteV3CustomerAddressById>>, TError,DeleteV3CustomerAddressByIdMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteV3CustomerAddressById>>, TError,DeleteV3CustomerAddressByIdMutationVariables, TContext> => {

const mutationKey = getDeleteV3CustomerAddressByIdMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteV3CustomerAddressById>>, DeleteV3CustomerAddressByIdMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteV3CustomerAddressById(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteV3CustomerAddressByIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteV3CustomerAddressById>>>

    export type DeleteV3CustomerAddressByIdMutationError = ErrorType<unknown>
    export type DeleteV3CustomerAddressByIdMutationVariables = {id: string}

    /**
 * @summary Delete a customer address
 */
export const useDeleteV3CustomerAddressById = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteV3CustomerAddressById>>, TError,DeleteV3CustomerAddressByIdMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteV3CustomerAddressById>>,
        TError,
        DeleteV3CustomerAddressByIdMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteV3CustomerAddressByIdMutationOptions(options), queryClient);
    }
    /**
 * Creates a new entitlement for an existing customer address
 * @summary Add an entitlement to a customer address
 */
export const postV3CustomerAddressEntitlements = (
    id: string,
    postV3CustomerAddressEntitlementsBody: PostV3CustomerAddressEntitlementsBody,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<V3CustomerAddressEntitlement>(
      {url: `/v3/customer-addresses/${id}/entitlements`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postV3CustomerAddressEntitlementsBody, signal
    },
      options);
    }




export const getPostV3CustomerAddressEntitlementsMutationKey = () => ['postV3CustomerAddressEntitlements'] as const;

export const getPostV3CustomerAddressEntitlementsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV3CustomerAddressEntitlements>>, TError,PostV3CustomerAddressEntitlementsMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postV3CustomerAddressEntitlements>>, TError,PostV3CustomerAddressEntitlementsMutationVariables, TContext> => {

const mutationKey = getPostV3CustomerAddressEntitlementsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postV3CustomerAddressEntitlements>>, PostV3CustomerAddressEntitlementsMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  postV3CustomerAddressEntitlements(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostV3CustomerAddressEntitlementsMutationResult = NonNullable<Awaited<ReturnType<typeof postV3CustomerAddressEntitlements>>>
    export type PostV3CustomerAddressEntitlementsMutationBody = PostV3CustomerAddressEntitlementsBody
    export type PostV3CustomerAddressEntitlementsMutationError = ErrorType<unknown>
    export type PostV3CustomerAddressEntitlementsMutationVariables = {id: string;data: PostV3CustomerAddressEntitlementsBody}

    /**
 * @summary Add an entitlement to a customer address
 */
export const usePostV3CustomerAddressEntitlements = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV3CustomerAddressEntitlements>>, TError,PostV3CustomerAddressEntitlementsMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postV3CustomerAddressEntitlements>>,
        TError,
        PostV3CustomerAddressEntitlementsMutationVariables,
        TContext
      > => {
      return useMutation(getPostV3CustomerAddressEntitlementsMutationOptions(options), queryClient);
    }
    /**
 * Marks an entitlement as pending removal for ops processing
 * @summary Remove an entitlement from a customer address
 */
export const deleteV3CustomerAddressEntitlement = (
    id: string,
    entitlementId: string,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<boolean>(
      {url: `/v3/customer-addresses/${id}/entitlements/${entitlementId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteV3CustomerAddressEntitlementMutationKey = () => ['deleteV3CustomerAddressEntitlement'] as const;

export const getDeleteV3CustomerAddressEntitlementMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteV3CustomerAddressEntitlement>>, TError,DeleteV3CustomerAddressEntitlementMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteV3CustomerAddressEntitlement>>, TError,DeleteV3CustomerAddressEntitlementMutationVariables, TContext> => {

const mutationKey = getDeleteV3CustomerAddressEntitlementMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteV3CustomerAddressEntitlement>>, DeleteV3CustomerAddressEntitlementMutationVariables> = (props) => {
          const {id,entitlementId} = props ?? {};

          return  deleteV3CustomerAddressEntitlement(id,entitlementId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteV3CustomerAddressEntitlementMutationResult = NonNullable<Awaited<ReturnType<typeof deleteV3CustomerAddressEntitlement>>>

    export type DeleteV3CustomerAddressEntitlementMutationError = ErrorType<unknown>
    export type DeleteV3CustomerAddressEntitlementMutationVariables = {id: string;entitlementId: string}

    /**
 * @summary Remove an entitlement from a customer address
 */
export const useDeleteV3CustomerAddressEntitlement = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteV3CustomerAddressEntitlement>>, TError,DeleteV3CustomerAddressEntitlementMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteV3CustomerAddressEntitlement>>,
        TError,
        DeleteV3CustomerAddressEntitlementMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteV3CustomerAddressEntitlementMutationOptions(options), queryClient);
    }
